import React from 'react';
import { frames } from '#packages/panels';
const { MessagePanelFrame } = frames;

import type { MessagePanelFrameProps } from '../../frames/messagePanelFrame/messagePanelFrame';

interface GenericMessageProps {
  panelName: string;
  title: string;
  message: string | React.ReactNode;
  primaryButton: {
    label: string;
  };
  dataHook: string;
  onConfirm(): void;
  confirmLabel: string;
  close: () => {};
  theme?: MessagePanelFrameProps['theme'];
}

const GenericMessage: React.FC<GenericMessageProps> = ({
  title,
  message,
  dataHook,
  confirmLabel,
  onConfirm,
  close,
  theme,
}) => {
  return (
    <MessagePanelFrame
      panelName={'GenericMessage'}
      title={title}
      confirmLabel={confirmLabel}
      onConfirm={onConfirm}
      dataHook={dataHook}
      onCancel={close}
      theme={theme}
    >
      {message}
    </MessagePanelFrame>
  );
};

export default GenericMessage;
